import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useWebMcp } from './useWebMcp';
import { publicTools, accountTools } from './tools';
import WebMcpBadge from './WebMcpBadge';

/**
 * Mounts the always-on WebMCP tools.
 *
 * Discovery tools are up for everyone, including an agent arriving cold. The
 * account tools — library, generation, payouts — only appear once there is a
 * session to act on, because a tool that can only ever answer "you are not
 * signed in" is a tool that wastes context on every single prompt.
 */
export default function WebMcpTools() {
  const { isAuthed } = useAuth();
  useWebMcp(isAuthed ? 'webmcp:signed-in' : 'webmcp:public', () =>
    isAuthed ? [...publicTools(), ...accountTools()] : publicTools()
  );
  return <WebMcpBadge />;
}
